<template>
  <div>
    <b-tabs>
      <b-tab :title="$t('message.Общие')" active>
        <b-row>
          <b-col class="col-6">
            <b-form-group
              :label="$t('message.Название') + ':'"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                type="text"
                v-model="model.name"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              :label="$t('message.Описание') + ':'"
              label-for="Comment"
            >
              <b-form-input
                id="Comment"
                type="text"
                v-model="model.comment"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="model.enabled" switch>
                {{ $t("message.Включен") }}</b-form-checkbox
              >
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="model.public" switch>
                {{ $t("message.Выводить_на_сайте") }}</b-form-checkbox
              >
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="model.market_accessable" switch>
                {{ $t("message.Выгружать_в_ios") }}</b-form-checkbox
              >
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="model.android_accessable" switch>
                {{ $t("message.Выгружать_в_android") }}</b-form-checkbox
              >
            </b-form-group>
            <b-form-group
              :label="$t('message.Минимальный_возраст') + ':'"
              label-for="Rating"
            >
              <b-form-input
                id="Rating"
                type="number"
                v-model="model.min_age"
                value="0"
                min="0"
                max="21"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-6">
            <b-form-group :label="$t('message.Логотип')" label-for="Logo">
              <b-form-file
                accept="image/*"
                v-model="model.image"
                @change="onFileChange"
                :state="Boolean(model.image)"
                placeholder="Choose a file..."
              ></b-form-file>
              <div class="mt-3" v-if="!epg_image && model.image_url">
                <img :src="model.image_url" width="64" />
              </div>
              <div class="mt-3" v-if="epg_image">
                <img :src="epg_image" width="64" />
              </div>
              <!-- Plain mode -->
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :label="$t('message.Пакеты') + ':'" label-for="Packages">
          <v-select
            multiple
            v-model="model.packages"
            :options="this.packages"
            label="name"
          ></v-select>
        </b-form-group>
        <b-form-group
          :label="$t('message.Категории') + ':'"
          label-for="Categories"
        >
          <v-select
            multiple
            v-model="model.categories"
            :options="this.categories"
            label="name"
          ></v-select>
        </b-form-group>
      </b-tab>
      <b-tab :title="$t('message.Geo_контроль')">
        <b-form-group>
          <b-form-checkbox v-model="model.geo_enabled" switch>{{
            $t("message.Geo_enabled")
          }}</b-form-checkbox>
        </b-form-group>
        <b-form-group :label="$t('message.Geo_тип_списка')">
          <b-form-radio-group>
            <b-form-radio
              v-model="model.geo_type_list"
              name="GeoTypeList"
              value="BLACK"
              >Black</b-form-radio
            >
            <b-form-radio
              v-model="model.geo_type_list"
              name="GeoTypeList"
              value="WHITE"
              >White</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>
        <b-form-group :label="$t('message.Geo_коды')" label-for="Countries">
          <v-select
            multiple
            v-model="model.geo_codes"
            :options="this.geo_codes_list"
            label="name"
          ></v-select>
        </b-form-group>
      </b-tab>
      <b-tab title="EPG">
        <b-form-group label="EPG Channel:" label-for="EPGChannel">
          <v-select
            v-model="model.epg_channel"
            :options="this.epg_channels"
            label="name"
          ></v-select>
        </b-form-group>
        <b-form-group v-if="model.epg_channel" label-for="ImportImage">
          <b-form-checkbox
            v-model="model.import_epgchannel_image"
            @change="update_image"
            switch
            >{{ $t("message.Импортировать_лого") }}</b-form-checkbox
          >
        </b-form-group>
        <b-form-group
          :label="$t('message.Коррекция_времени_EPG') + ':'"
          label-for="EgpCorrection"
        >
          <b-form-input
            id="EgpCorrection"
            type="number"
            v-model="model.epg_offset"
          ></b-form-input>
        </b-form-group>

        <b-form-group v-if="model.epg_channel" label-for="ApplyEpgCorrection">
          <b-form-checkbox v-model="model.apply_epg_correction" switch>{{
            $t("message.Применять_точные_метки")
          }}</b-form-checkbox>
        </b-form-group>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
export default {
  name: "ChannelForm",
  props: ["model"],
  data() {
    return {
      packages: [],
      streams: [],
      categories: [],
      epg_channels: [],
      epg_image: null,
      geo_codes_list: []
    };
  },
  beforeUpdate() {},
  created: function() {
    this.epg_image = null;
    let promise = this.$noname.get("packages", { params: { perPage: 10000 } });
    let categories = this.$noname.get("categories", {
      params: { perPage: 10000 }
    });
    let epg_channels = this.$noname.get("epg_sources_channels");
    let geo_codes_list = this.$noname.get("geo_country_codes", {
      params: { perPage: 10000 }
    });

    promise
      .then(data => {
        this.packages = data.data.items;
      })
      .catch(this.$noname.HandleError);

    categories
      .then(data => {
        this.categories = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Ошибка_получения_данных") + ":<br>" + error,
          type: "error"
        });
      });

    epg_channels
      .then(data => {
        this.epg_channels = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t(
              "message.Не_удалось_получить_список_каналов_источников"
            ) +
            ":<br>" +
            error,
          type: "error"
        });
      });

    geo_codes_list
      .then(data => {
        this.geo_codes_list = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Geo_не_удалось_получить_список_кодов_стран") +
            ":<br>" +
            error,
          type: "error"
        });
      });
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.model.image = reader.result;
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    update_image(checked) {
      this.epg_image = checked ? this.model.epg_channel.image_url : null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/ChannelForm.vue